export var EFFECTIVE_IMMEDIATELY = 'immediately';
export var EFFECTIVE_NEXT_CYCLE = 'next-cycle';